import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zhCN from './locales/zh-CN';
import enUS from './locales/en-US';
import frFR from './locales/fr-FR';
import deDE from './locales/de-DE';
import jaJP from './locales/ja-JP';
import koKR from './locales/ko-KR';
import esES from './locales/es-ES';
import ptPT from './locales/pt-PT';
import arSA from './locales/ar-SA';
import msMY from './locales/ms-MY';

Vue.use(VueI18n);

const LOCALE_STORAGE_KEY = 'app:locale';

export const supportedLocales = [
  { code: 'zh-CN', label: '简体中文' },
  { code: 'en-US', label: 'English' },
  { code: 'fr-FR', label: 'Français' },
  { code: 'de-DE', label: 'Deutsch' },
  { code: 'ja-JP', label: '日本語' },
  { code: 'ko-KR', label: '한국어' },
  { code: 'es-ES', label: 'Español' },
  { code: 'pt-PT', label: 'Português' },
  { code: 'ar-SA', label: 'العربية' },
  { code: 'ms-MY', label: 'Bahasa Melayu' },
];

function getStorage() {
  if (typeof window !== 'undefined' && window.localStorage)
    return window.localStorage;
  return {
    getItem() {
      return null;
    },
    setItem() {},
  };
}

const storage = getStorage();
const savedLocale = storage.getItem(LOCALE_STORAGE_KEY);
const defaultLocale = savedLocale || 'zh-CN';

export const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'en-US',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
    'fr-FR': frFR,
    'de-DE': deDE,
    'ja-JP': jaJP,
    'ko-KR': koKR,
    'es-ES': esES,
    'pt-PT': ptPT,
    'ar-SA': arSA,
    'ms-MY': msMY,
  },
  silentTranslationWarn: true,
});

export function setLocale(locale) {
  i18n.locale = locale;
  storage.setItem(LOCALE_STORAGE_KEY, locale);
}
